export const __TOKEN__ = 'token-registry';
export const __EMAIL__ = 'token-registry-email';
